(() => {
  if (window.sgdVideoStoriesBound) return;
  window.sgdVideoStoriesBound = true;
  const prepared = new WeakSet();
  const prepare = (root = document) => root.querySelectorAll('.sgd-video-story video').forEach(video => {
    if (prepared.has(video)) return;
    prepared.add(video);
    const card = video.closest('.sgd-video-story');
    const controls = card.querySelector('.sgd-video-story__controls');
    const play = card.querySelector('[data-video-play]');
    const sound = card.querySelector('[data-video-mute]');
    const title = card.querySelector('h3').textContent;
    video.controls = false;
    controls.hidden = false;
    const sync = () => {
      card.classList.toggle('is-playing', !video.paused);
      card.classList.toggle('has-sound', !video.muted);
      play.setAttribute('aria-label', `${video.paused ? 'Play' : 'Pause'} video: ${title}`);
      sound.setAttribute('aria-label', `${video.muted ? 'Unmute' : 'Mute'} video: ${title}`);
      sound.setAttribute('aria-pressed', String(!video.muted));
    };
    ['play', 'pause', 'ended', 'volumechange'].forEach(name => video.addEventListener(name, sync));
    video.addEventListener('play', () => {
      document.querySelectorAll('.sgd-video-story video').forEach(other => {if (other !== video) other.pause();});
    });
    video.addEventListener('timeupdate', () => {card.querySelector('.sgd-video-story__progress span').style.transform = `scaleX(${video.duration ? video.currentTime / video.duration : 0})`;});
    sync();
  });
  document.addEventListener('click', async event => {
    const arrow = event.target.closest('[data-video-direction]');
    if (arrow) {
      const track = arrow.closest('.sgd-video-stories').querySelector('.sgd-video-stories__track');
      const card = track.querySelector('.sgd-video-story');
      if (card) track.scrollBy({left: Number(arrow.dataset.videoDirection) * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      return;
    }
    const card = event.target.closest('.sgd-video-story');
    if (!card) return;
    const video = card.querySelector('video');
    if (!video) return;
    if (event.target.closest('[data-video-mute]')) {video.muted = !video.muted;return;}
    if (event.target.closest('[data-video-play]') || event.target === video) {
      if (!video.paused) video.pause();
      else {
        const error = card.querySelector('.sgd-video-story__error');
        error.textContent = '';
        try {await video.play();} catch {error.textContent = 'This video could not play. Please try again.';}
      }
    }
  });
  document.addEventListener('visibilitychange', () => {if (document.hidden) document.querySelectorAll('.sgd-video-story video').forEach(video => video.pause());});
  document.addEventListener('shopify:section:load', event => prepare(event.target));
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('.sgd-video-story');
    if (!card) return;
    const track = card.closest('.sgd-video-stories__track');
    track.scrollBy({left:card.getBoundingClientRect().left - track.getBoundingClientRect().left,behavior:'auto'});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare());
  else prepare();
})();
